import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Insomnia } from "@awesome-cordova-plugins/insomnia/ngx";
import { Router } from "@angular/router";
import {
  Firestore,
  collectionData,
  CollectionReference,
  where,
  getDocs,
  query as firestoreQuery,
  Timestamp,
  doc,
  getDoc,
  collection,
  writeBatch,
  setDoc,
  updateDoc,
} from "@angular/fire/firestore";

import {
  Storage,
  ref,
  listAll,
  ListResult,
  StorageReference,
  getMetadata,
  list,
} from "@angular/fire/storage";

import {
  Subject,
  Subscription,
  timer,
  from,
  Observable,
  of,
  lastValueFrom,
  firstValueFrom,
} from "rxjs";
import {
  map,
  mergeMap,
  takeUntil,
  filter,
  tap,
  timeout,
  catchError,
  takeWhile,
} from "rxjs/operators";

//********************import services******************* */
import { FirestoreService } from "@shared/services/firestore.service"; //to access the firebase
import { ModalService } from "@shared/services/modal.service"; //to interact with the modal dialog like close the dialog
import { DeviceService } from "@shared/state/device/device.service";
import { ConnectApiService } from "@shared/services/connectapi.service";
import { StorageService } from "@shared/services/storage.service";
import { FirmwareService } from "@shared/state/firmware/firmware.service";
import { RemoteSupportService } from "@services/remote-support.service";
import { BleWebService } from "@shared/services/ble/ble-web.service";
import { RemoteUserService } from "@shared/state/remote-user/remote-user.service";
import { UserService } from "@shared/state/user/user.service";

import { FirmwareQuery } from "@shared/state/firmware/firmware.query";
import { DeviceQuery } from "@shared/state/device/device.query";
import { DefinitionsQuery } from "@shared/state/definitions/definitions.query";
import { RemoteUserQuery } from "@state/remote-user/remote-user.query";
//**************constants**************** */
import { CONFIG } from "@shared/constants/config";
import { environment } from "@env/environment";
//*****************************Interfaces****************************** */
import {
  ICurrentDevice,
  IParameterData,
  IHardwareVersion,
  stringparametertemp,
} from "@shared/interfaces/device.interface";
import { IstringParameterForUpdate } from "@shared/interfaces/request.interface";
import {
  IFirmwareUpgrade,
  IFirmwareUpgradeSparePart,
} from "@interfaces/request.interface";

import { ParamResponseResult } from "connectapi/src/CAN_Messages/CanMessages";
import { StringParameterEventType } from "connectapi/src/ApiMessage/apiResponseTypes";
import {
  IFirmwareFile,
  ITarget,
  SelectedFile,
} from "@shared/interfaces/firmware.interface";
import { ECU_ID } from "connectapi/src/CAN_Messages/CanEnums";

@Component({
  selector: "app-spare-part-modal-service",

  templateUrl: "./spare-part-modal-service.component.html",
  styleUrl: "./spare-part-modal-service.component.scss",
})
export class SparePartModalServiceComponent implements OnInit, OnDestroy {
  @Input()
  public role!: string;
  public isRemoteSessionActive!: boolean;
  public serialNumber: string = ""; //serial number of the unit entered by the user to identified the existing unit in database
  public serialNumberInput: string = "";
  public softwareVarient: number | null = -1; //variable to save the vale of softwareVarient of unit fond with entered serial number
  public softwareVarientType: string | null = null;
  public lastConnectedDate: Date | null = null;
  public unitBackupDate: Date | null = null;
  public backupVersion: any | null = null;
  public step: number = 1; // for the navigation of dialog pages

  public parameter!: IParameterData;
  public ecuName: string = "";

  public fetchFactorySettings!: boolean;

  public firmwareUpdateCancel: boolean = false;

  public items: any = []; //array for released version firmware
  public changedItems = []; //array for special/protected version firmware
  public checkBoxes: any[] = [];
  public checkBoxes$!: Observable<any>;
  public fileSelected: boolean = false;
  public isChecked: boolean = false;
  public isFirmwareDiff: boolean = false;
  public firmwareSent: boolean = false;
  public firmwareSparePart!: IFirmwareFile;
  public selectedFile!: string | null; //file selected in filepicker
  public firmwareName: string | null = null;

  public softwareVersionHeartBeat: number | null = null;
  public softwareFile!: StorageReference | undefined;
  public changedSoftwareFile!: StorageReference | undefined;

  public autoSoftwareFile!: StorageReference | undefined;
  public firmwareToSend!: StorageReference | undefined;
  private hardwareSubs!: Subscription;
  public upgradeProgressSparePart$ = this.firmwareQuery.upgradeProgress$;
  public ongoingUpgradeSparePart$ = this.firmwareQuery.ongoingUpgrade$;
  private upgradeProgressSubscription!: Subscription;
  public firmwarePrepared = false;
  public currentSparepartUnit: IHardwareVersion | null = null;

  private writingData = false;
  private writingData$ = new Subject<boolean>();
  private parametersAndStringParametersForBackupSubscription!: Subscription;
  private HMI_SERIAL_NUMBER = 6;
  public hasInvalidInput = false;
  private invalidTimeout: any;

  ////////////////
  public remoteSessionIsActive$ = this.remoteUserQuery.isActive$;
  public searchingSparePart: boolean = false;
  /////////////////

  constructor(
    private angularFireStorage: Storage,
    private httpClient: HttpClient,
    private insomnia: Insomnia,
    private router: Router,
    //services//
    private modalService: ModalService,
    private firestoreService: FirestoreService,
    private deviceService: DeviceService,
    private storageService: StorageService,
    private angularFirestore: Firestore,
    private firmwareService: FirmwareService,
    private connectApiService: ConnectApiService,
    private bleWebService: BleWebService,
    private userService: UserService,
    private remoteUserService: RemoteUserService,
    //Queries//
    private deviceQuery: DeviceQuery,
    private definitionQuery: DefinitionsQuery,
    private firmwareQuery: FirmwareQuery,
    private remoteUserQuery: RemoteUserQuery,
    private remoteSupportService: RemoteSupportService,
  ) {}

  ngOnInit(): void {
    this.step = 1;
    this.ecuName = this.getEcuNameFromEcuId(this.parameter.ecuId);
    this.softwareVersionHeartBeat = null;
    //  console.log("this.isRemoteSessionActive", this.isRemoteSessionActive);
  }
  onKeyDown(event: KeyboardEvent) {
    // console.log("key pressed:", event.key); // 👈 confirm handler fires
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      "Enter",
    ];

    const isNumber = /^[0-9]$/.test(event.key);
    const isAllowed = allowedKeys.includes(event.key);

    if (!isNumber && !isAllowed) {
      event.preventDefault(); // block the character from appearing

      // show error
      this.hasInvalidInput = true;
      //console.log("hasInvalidInput set to true"); // 👈 confirm flag is set
      clearTimeout(this.invalidTimeout);
      this.invalidTimeout = setTimeout(() => {
        this.hasInvalidInput = false;
      }, 2000);
    } else {
      // valid input — get the value for your serial number logic
      const input = event.target as HTMLInputElement;
      this.getSerialNumber(input.value);
    }
  }

  private getEcuNameFromEcuId(ecuID: number): string {
    switch (ecuID) {
      case 1:
        return "TCU";

      case 2:
        return "CCU";

      case 6:
        return "HMI";

      default:
        return "Unknown";
    }
  }

  public getSerialNumber(value: string) {
    this.serialNumber = value.trim(); // trim to remove leading/trailing whitespaces
  }

  public async findSoftwareVersionHeartBeat(): Promise<number | null> {
    //  console.log("findSoftwareVersionHeartBeat: waiting...");

    return firstValueFrom(
      this.deviceQuery.hardwareVersions$.pipe(
        /* tap((hardwareVersions) =>
          console.log(
            "emission received, array length:",
            hardwareVersions.length,
            hardwareVersions,
          ),
        ),*/
        map((hardwareVersions) =>
          hardwareVersions.find((x) => x.ecuId === this.parameter.ecuId),
        ),
        /*  tap((unit) =>
          console.log(
            "unit found:",
            unit,
            "softwareVarient:",
            unit?.softwareVarient,
            "softwareSubVarient:",
            unit?.softwareSubVarient,
          ),
        ),*/
        filter((unit) => !!unit?.softwareVarient),
        timeout(10000), // give up after 10 seconds
        catchError((err) => {
          console.warn(
            "findSoftwareVersionHeartBeat timed out or errored:",
            err,
          );
          return of(null);
        }),
        map((unit) => {
          if (!unit) return null;
          if (unit.softwareSubVarient === 99) return null;
          this.currentSparepartUnit = unit;
          return unit.softwareVarient ?? null;
        }),
      ),
    );
  }

  public async searchOnSerialNumber(): Promise<void> {
    this.searchingSparePart = true;
    try {
      this.serialNumberInput = this.serialNumber?.trim() ?? "";
      if (!this.serialNumberInput) {
        return;
      }
      this.items = [];
      this.autoSoftwareFile = undefined;
      this.lastConnectedDate = null;
      this.unitBackupDate = null;

      const [result, backupDeviceInfo, softwareVersionHeartBeat] =
        await Promise.all([
          this.findDeviceOnSerial(this.serialNumberInput),
          this.findBackupOnSerial(this.serialNumberInput),
          this.findSoftwareVersionHeartBeat(),
        ]);
      //console.log("detai", result, backupDeviceInfo, softwareVersionHeartBeat);
      this.softwareVersionHeartBeat = softwareVersionHeartBeat;
      if (backupDeviceInfo) {
        const { backupDate, backupVersion } = backupDeviceInfo;

        if (backupDate === null || backupDate === undefined) {
          this.unitBackupDate = null;
          // console.log(backupDate, this.unitBackupDate);
        } else {
          this.unitBackupDate = backupDate?.toDate();
          // console.log("this.unitBackupDate is available");
        }
        if (backupVersion === null) {
          this.backupVersion = null;
          // console.log("this.backupVersion", this.backupVersion);
        } else {
          this.backupVersion = "available";
          //  console.log("this.backupVersion is available", this.backupVersion);
        }
      }
      // Nothing found at all
      if (!backupDeviceInfo && !result) {
        this.step = -1;
        this.serialNumber = "";
        return;
      }
      //if found
      this.step = 2;
      // If device exists in devices of Firebase
      if (result) {
        const { softwareVariant, lastConnected } = result;
        this.softwareVarient = softwareVariant;
        this.lastConnectedDate = lastConnected ?? null;
      } else {
        // If only backup exists, rely on heartbeat version
        this.softwareVarient = this.softwareVersionHeartBeat || null;
      }
      const softwareVarientInternal = this.softwareVarient;
      const softwareVersionHeartBeatInternal = this.softwareVersionHeartBeat;

      const hasMatchingVariant =
        softwareVarientInternal != null &&
        softwareVersionHeartBeatInternal != null &&
        softwareVarientInternal > 0 &&
        softwareVarientInternal === softwareVersionHeartBeatInternal;

      if (hasMatchingVariant) {
        this.softwareVarientToText(softwareVarientInternal);
        await this.loadReleasedFirmware(softwareVarientInternal);
      } else {
        this.softwareVarient = null;
      }
    } catch (error) {
      console.error("Error while searching on serial number:", error);
      this.step = -1;
    } finally {
      this.searchingSparePart = false;
    }
  }
  private async loadReleasedFirmware(softwareVariant: number): Promise<void> {
    const firmwareRef = ref(
      this.angularFireStorage,
      `systemversion/${softwareVariant}/0/release`,
    );

    const listResult = await listAll(firmwareRef);

    const metadataList = await Promise.all(
      listResult.items.map((item) => getMetadata(item)),
    );

    this.items = metadataList.map((metaData) => ({
      ...metaData,
      truncatedName: metaData.name
        .split("_")
        .slice(1)
        .join("_")
        .replace(".json", ""),
    }));

    this.autoSoftwareFile = this.items[0];

    if (this.autoSoftwareFile) {
      await this.preparingFirmware(this.autoSoftwareFile);
    }
  }
  private getSerialParamId(ecuId: number): number | null {
    switch (ecuId) {
      case 1:
        return 74;
      case 2:
        return 137;
      default:
        return null; // unknown ecu -> cannot verify
    }
  }

  private async findBackupOnSerial(
    serialNumber: string,
  ): Promise<{ backupDate: Timestamp; backupVersion: any } | null> {
    const isHmi = this.ecuName === "HMI";
    const effectiveSerial = isHmi
      ? this.HMI_SERIAL_NUMBER
      : Number(serialNumber);

    if (!Number.isFinite(effectiveSerial)) return null;

    try {
      const backupDocRef = doc(
        this.angularFirestore,
        `${CONFIG.firebaseCollection.backups}/${effectiveSerial}-0`,
      );
      const subCollectionRef = collection(backupDocRef, "backupParameters");

      const [docSnap, querySnapshot] = await Promise.all([
        getDoc(backupDocRef),
        getDocs(subCollectionRef),
      ]);

      if (!docSnap.exists() || querySnapshot.empty) return null;

      // NEW CHECK (non-HMI only)
      if (!isHmi) {
        const serialParamId = this.getSerialParamId(this.parameter.ecuId);

        if (serialParamId === null) return null;

        type ParamItem = { ecuId: number; parameterId: number; value: number };
        type BackupParamDoc = { parameterData?: ParamItem[] };

        const isSerialVerified = querySnapshot.docs.some((d) => {
          const data = d.data() as BackupParamDoc;
          const items = data.parameterData ?? [];
          return items.some(
            (p) =>
              p.parameterId === serialParamId && p.value === effectiveSerial,
          );
        });

        if (!isSerialVerified) {
          /*  console.log(
            "return null: serial was not verified in backupParameters",
          );*/
          return null;
        }
      }
      const data = docSnap.data();

      if (!data) {
        // console.log("return null: docSnap.data() missing");
        return null;
      }

      return {
        backupDate: data["backupDate"] as Timestamp,
        backupVersion: data,
      };
    } catch (error) {
      console.error("Error querying Firestore:", error);
      return null;
    }
  }

  private async findDeviceOnSerial(serialNumber: string) {
    //  console.log("findDeviceOnSerial", serialNumber);
    if (serialNumber) {
      try {
        const q = firestoreQuery(
          collection(this.angularFirestore, CONFIG.firebaseCollection.devices),
          where("address", "==", serialNumber),
          where("ecuId", "==", this.parameter.ecuId),
        );

        const unitFound = await getDocs(q);
        //  console.log(unitFound);
        const mapped = unitFound.docs.map((y) => ({
          ...(y.data() as any),
          uid: y.id,
        }));
        //  console.log(mapped);
        const unitData = mapped.find(
          (device) => !device.isSparePart && !device.isInactive,
        );
        //  console.log(unitData);
        if (!unitData) {
          console.warn(
            `Device with serial number "${serialNumber}" not found or is inactive/spare.`,
          );

          return null;
        }
        return {
          softwareVariant: unitData?.softwareVarient,
          uid: unitData?.uid,
          lastConnected: (unitData?.lastConnected as Timestamp).toDate(),
        };
      } catch (error) {
        console.error("Error querying Firestore:", error);
      }
    }
  }

  private softwareVarientToText(softwareVarient: number) {
    switch (softwareVarient) {
      case 2:
        this.softwareVarientType = "RCS";
        break;
      case 3:
        this.softwareVarientType = "Standalone";
        break;
      case 4:
        this.softwareVarientType = "MIC 4.0";
        break;
      case 5:
        this.softwareVarientType = "RCS II";
        break;
      case 6:
        this.softwareVarientType = "GSA";
        break;
      default:
        this.softwareVarientType = null;
        break;
    }
  }

  public async preparingFirmware(theFirmware: StorageReference) {
    if (theFirmware) {
      this.firmwareToSend = theFirmware;
      const firmwareUpgrade: IFirmwareUpgrade = {
        version: "1.0.0",
        fullPath: theFirmware.fullPath,
        name: theFirmware.name,
      };

      try {
        const jsonData = await lastValueFrom(
          this.httpClient.get<IFirmwareFile>(
            environment.functions.storageDownload,
            {
              responseType: "json",
              params: { path: firmwareUpgrade.fullPath },
            },
          ),
        );

        const fileIsSaved = await this.storageService.fileWrite(
          jsonData,
          firmwareUpgrade.fullPath,
        );
        if (fileIsSaved) {
          this.fileSelected = true;
          // console.log('Your file has been downloaded', this.fileSelected);
        } else {
          this.fileSelected = false;
          // console.log('Something went wrong while downloading');
        }

        this.firmwareSparePart = jsonData;

        this.prepareCheckbox(this.firmwareSparePart, firmwareUpgrade.fullPath);
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    }
  }

  private prepareCheckbox(firmware: IFirmwareFile, firmwareName: string) {
    //  console.log("preparing checkbox");

    this.checkBoxes = [];
    this.checkBoxes$ = of(this.checkBoxes);
    var matched = firmware.targets?.find(
      (x) => x.ecuId === this.parameter.ecuId,
    );

    this.checkBoxes.push({
      disabled: false,
      value: matched?.ecuName,
      ecuId: matched?.ecuId ?? matched?.hexFileDefinitions[0].ecuId,
      fromBuildNumber: null,
      toBuildNumber: null,
      isItemChecked: true,
    });

    this.checkBoxes$ = of(this.checkBoxes);
    // console.log("checkbox", this.checkBoxes.length, this.checkBoxes);

    if (this.checkBoxes.length > 0) {
      this.firmwarePrepared = true;
      var truncatedName = firmwareName
        .split("_")
        .slice(1)
        .join("_")
        .replace(".json", "");

      this.firmwareName = truncatedName;

      //  console.log("this.firmwarePrepared", this.firmwarePrepared);
    }
  }

  private getSerialnumberFromEcuId(ecuId: number): string {
    switch (ecuId) {
      case 1:
        return (
          this.deviceQuery.specificParameterData(1074)?.value?.toString() ?? ""
        );

      case 2:
        return (
          this.deviceQuery.specificParameterData(2137)?.value?.toString() ?? ""
        );
      default:
        return "";
    }
  }

  private getHardwareNumberFromEcuId(ecuId: number): string {
    switch (ecuId) {
      case 1:
        return (
          this.deviceQuery.specificParameterData(1008)?.value?.toString() ?? ""
        );

      case 2:
        return (
          this.deviceQuery.specificParameterData(2008)?.value?.toString() ?? ""
        );
      default:
        return "";
    }
  }

  //for previous settings
  public handleGetPrevious() {
    this.deviceService.setIsBackuping(true);
    this.fetchOldSettings();
    this.step = 5;
  }

  public async fetchOldSettings() {
    var currentSerialNumber = this.getSerialnumberFromEcuId(
      this.parameter.ecuId,
    );
    var currentHardwareNumber = this.getHardwareNumberFromEcuId(
      this.parameter.ecuId,
    );
    this.fetchFactorySettings = false;
    this.firestoreService
      .fetchBackupParametersForSerialNumber(
        this.serialNumberInput,
        this.parameter.ecuId,
        this.fetchFactorySettings,
        currentHardwareNumber,
      )
      .then(async (res) => {
        this.firestoreService
          .logBackup(
            currentSerialNumber,
            this.parameter?.ecuId === 6
              ? (this.deviceQuery?.parameterData
                  .find((x) => x.parameterId === 6008)
                  ?.value?.toString() ?? "")
              : this.serialNumber,
            this.getEcuNameFromEcuId(this.parameter.ecuId),
          )
          .then(() => {
            try {
              //console.log(res.parameterData);
              this.writeParameters(res.parameterData);
              this.startSubscribeForBackUpParameters(
                res,
                currentHardwareNumber,
              );
            } catch (error) {
              console.error(error);
              // this.noUnitFound(this.serialNumber);
            }
          })
          .catch((error) => {
            console.error("COULD NOT LOG DATA", error);
            //this.noUnitFound(this.qrResult);
            this.serialNumber = "";
            this.step = 5;
          });
      })
      .catch((err) => {
        console.error("COULD NOT FETCH BACKUP PARAMETERS", err);
        // this.noUnitFound(this.qrResult);
        this.serialNumber = "";
        this.step = 5;
      });
  }

  public handleGetBackup() {
    this.step = 5;
    this.deviceService.setIsBackuping(true);
    this.fetchFactorySettings = true;
    var currentSerialNumber = this.getSerialnumberFromEcuId(
      this.parameter.ecuId,
    );
    var currentHardwareNumber = this.getHardwareNumberFromEcuId(
      this.parameter.ecuId,
    );
    // console.log(this.serialNumber);

    this.firestoreService
      .fetchBackupParametersForSerialNumber(
        this.serialNumberInput,
        this.parameter.ecuId,
        this.fetchFactorySettings,
        currentHardwareNumber,
      )
      .then(async (res) => {
        this.firestoreService
          .logBackup(
            currentSerialNumber,
            this.parameter.ecuId === 6
              ? (this.deviceQuery.parameterData
                  .find((x) => x.parameterId === 6008)
                  ?.value?.toString() ?? "")
              : this.serialNumber,
            this.getEcuNameFromEcuId(this.parameter.ecuId),
          )
          .then(() => {
            try {
              this.writeParameters(res.parameterData);
              this.startSubscribeForBackUpParameters(
                res,
                currentHardwareNumber,
              );
            } catch (error) {
              console.error(error);
            }
          })
          .catch((error) => {
            console.error("COULD NOT LOG DATA", error);

            this.serialNumber = "";
            this.step = 5;
          });
      })
      .catch((err) => {
        console.error("COULD NOT FETCH BACKUP PARAMETERS", err);

        this.serialNumber = "";
      });
  }

  public handleGetHMIBackup() {
    this.step = 5;
    this.deviceService.setIsBackuping(true);
    this.fetchFactorySettings = true;
    var currentSerialNumber = this.getSerialnumberFromEcuId(
      this.parameter.ecuId,
    );
    var currentHardwareNumber = this.getHardwareNumberFromEcuId(
      this.parameter.ecuId,
    );
    // console.log(this.serialNumber);

    this.firestoreService
      .fetchBackupParametersForSerialNumber(
        "6",
        this.parameter.ecuId,
        this.fetchFactorySettings,
        currentHardwareNumber,
      )
      .then(async (res) => {
        this.firestoreService
          .logBackup(
            currentSerialNumber,
            this.parameter.ecuId === 6
              ? (this.deviceQuery.parameterData
                  .find((x) => x.parameterId === 6008)
                  ?.value?.toString() ?? "")
              : this.serialNumber,
            this.getEcuNameFromEcuId(this.parameter.ecuId),
          )
          .then(() => {
            try {
              this.writeParameters(res.parameterData);
              this.startSubscribeForBackUpParameters(
                res,
                currentHardwareNumber,
              );
            } catch (error) {
              console.error(error);
              // this.noUnitFound(this.qrResult);
            }
          })
          .catch((error) => {
            console.error("COULD NOT LOG DATA", error);
            //this.noUnitFound(this.qrResult);
            this.serialNumber = "";
            this.step = 5;
          });
      })
      .catch((err) => {
        console.error("COULD NOT FETCH BACKUP PARAMETERS", err);
        //this.noUnitFound(this.qrResult);
        this.serialNumber = "";
      });
  }

  public updateFirmware() {
    // console.log("updateFirmware", this.checkBoxes);
    if (this.isRemoteSessionActive === false) {
      this.step = 3;
      this.firmwareService.setOngoing(true);
      const firmwareToSend = this.firmwareSparePart;
      const checkboxesToSend = this.checkBoxes;

      setTimeout(() => {
        this.connectApiService.updateFirmwareSparePart(
          firmwareToSend,
          checkboxesToSend,
        );
      }, 50);

      this.firmwareSparePart = {} as IFirmwareFile;
      this.softwareFile = {} as StorageReference;
      this.fileSelected = false;
      this.isChecked = false;
      this.isFirmwareDiff = false;

      this.upgradeProgressSubscription =
        this.upgradeProgressSparePart$.subscribe((progressArray) => {
          if (progressArray?.length > 0) {
            const progress = progressArray[0]; // directly get the first (and only) item
            // console.log(progress.progress, progress.updgradeStatus);

            if (
              progress.progress === 1 &&
              progress.updgradeStatus === "Finished" &&
              this.ecuName !== "HMI"
            ) {
              this.step = 4;

              setTimeout(() => {
                this.firmwareService.setOngoing(false);
                this.upgradeProgressSubscription?.unsubscribe();
              }, 2000);
            } else if (
              this.ecuName === "HMI" &&
              progress.progress === 1 &&
              progress.updgradeStatus === "Finished"
            ) {
              /* console.log(
              "update finished",
              progress.updgradeStatus,
              progressArray?.length,
            );*/
              this.step = 4;
              setTimeout(() => {
                // console.log("after 2000", progress.updgradeStatus);
                this.firmwareService.setOngoing(false);
                this.upgradeProgressSubscription?.unsubscribe();
                // this.closeModal();
              }, 2000);
            }
          }
        });
    } else {
      //this.firmwareService.setOngoing(true);
      this.firmwareSent = false;
      this.step = 8;
      // console.log("sending");

      const serialNoToSend = this.serialNumber;
      const operatorUid = this.remoteUserQuery.connectedUser?.uid || undefined;
      // console.log("sending", operatorUid, firmwareToSend);
      if (this.firmwareToSend) {
        var version = this.firmwareToSend.name
          .replace("systemversion_", "")
          .replace(".json", "");
        const firmwareUpgrade: IFirmwareUpgradeSparePart = {
          version: version ?? "1.0.0",
          fullPath: this.firmwareToSend.fullPath,
          name: this.firmwareToSend.name,
          serialNumber: serialNoToSend,
        };
        this.firmwareToSend = {} as StorageReference;

        this.remoteSupportService
          .updateFirmware(operatorUid, firmwareUpgrade)
          .then((reqDocument) => {
            this.remoteSupportService
              .subscribeToRequest(operatorUid, reqDocument.id)
              .pipe(takeWhile((x) => x.responded === false, true))
              .subscribe((request) => {
                if (request.responded) {
                  this.firmwareSent = true;

                  console.log("request responded", this.firmwarePrepared);
                }
              });
          });
      }
      this.softwareFile = {} as StorageReference;
    }
  }

  private async writeParameters(res: any) {
    this.writingData = true;
    this.deviceService.resetBackupParameters();

    if (this.parameter.ecuId === 6) {
      var dataWithStringParameters = res?.data() as {
        parameterData: IParameterData[];
        stringParameterData: stringparametertemp[];
      };
      let parameterData = dataWithStringParameters.parameterData ?? [];
      let stringParameterData =
        dataWithStringParameters.stringParameterData ?? [];

      if (this.fetchFactorySettings) {
        // FETCH DEFAULT SETTINGS FOR THE PARAMETERS THAT WERENT UPLOADED AT THE FACTORY
        const merged = this.mergedataWithStringParametersFromDefFile({
          parameterData,
          stringParameterData,
        });

        parameterData = merged?.parameterData ?? [];
        stringParameterData = merged?.stringParameterData ?? [];
      }

      for (var parameter of parameterData) {
        if (parameter.parameterId < 1000) {
          parameter.parameterId = 6 * 1000 + parameter.parameterId;
        }

        if (parameter.parameterId === 6107) {
          parameter.value = 0;
        }

        if (
          !parameter?.parameter ||
          parameter?.parameter?.accessType !== "RO"
        ) {
          var param = {
            parameterId: parameter.parameterId,
            ecuId: parameter.ecuId,
            value: parameter.value,
          };
          this.deviceService.addParameterForBackup(param);
          this.connectApiService.writeParameterToDevice(parameter);
          await this.sleep(15);
        }
      }
      await this.sleep(1500);
      for (const parameter of stringParameterData) {
        if (parameter.paramId < 1000) {
          parameter.paramId = 6 * 1000 + parameter.paramId;
        }
        var parameterToWrite: IstringParameterForUpdate = {
          parameterId: parameter.paramId,
          value: parameter.stringValue ?? "",
          ecuId: 6,
        };
        if (
          !parameter.parameter ||
          (parameter?.parameter?.accessType !== "RO" &&
            parameter.paramId !== 6300)
        ) {
          var stringParam = {
            parameterId: parameter.paramId,
            ecuId: 6,
            value: parameter.stringValue,
          };

          this.deviceService.addParameterForBackup(stringParam);
          this.connectApiService.writeStringParameterToDevice(parameterToWrite);
          await this.sleep(100);
        }
      }
    } else {
      var dataWithoutStringParameters = res?.data() as {
        parameterData: IParameterData[];
      };
      let parameterData = dataWithoutStringParameters.parameterData ?? [];
      if (this.fetchFactorySettings) {
        // FETCH DEFAULT SETTINGS FOR THE PARAMETERS THAT WERENT UPLOADED AT THE FACTORY

        const merged = this.mergedataWithoutStringParametersFromDefFile({
          parameterData,
        });
        parameterData = merged?.parameterData ?? [];
      }

      // console.log(dataWithoutStringParameters);
      for (var parameter of parameterData) {
        if (parameter.parameterId < 1000) {
          parameter.parameterId =
            this.parameter.ecuId * 1000 + parameter.parameterId;
        }

        if (parameter.parameterId === 1151 || parameter.parameterId === 2162) {
          parameter.value = 0;
        }
        /*
        if (parameter.parameterId === 1074 || parameter.parameterId === 2137) {
          parameter.value = parseInt(this.serialNumber);
        }*/

        if (!parameter.parameter || parameter?.parameter?.accessType !== "RO") {
          var param = {
            parameterId: parameter.parameterId,
            ecuId: this.parameter.ecuId as ECU_ID,
            value: parameter.value,
          };
          this.deviceService.addParameterForBackup(param);

          this.connectApiService.writeParameterToDevice(parameter);
          await this.sleep(15);
        }
      }
    }

    // this.startSubscribeForBackUpParameters(res, currentSerialNumber, currentHardwareNumber);
  }

  private startSubscribeForBackUpParameters(
    res: any,
    currentHardwareNumber: string,
  ) {
    // console.log('STARTING SUBSCRIPTION');
    this.parametersAndStringParametersForBackupSubscription =
      this.deviceQuery.parametersAndStringParametersForBackup$
        .pipe(
          takeUntil(timer(this.parameter.ecuId === 6 ? 30000 : 15000)),
          takeUntil(this.writingData$),
        )
        .subscribe({
          next: (params) => {
            //  console.log(`PARAM LEFT TO HANDLE ${params.length}`, params);

            if (params && params.length === 0) {
              // DONE
              this.writingData$.next(true);
            }
          },
          complete: async () => {
            //console.log('Data emission completed.');
            if (
              this.deviceQuery.parametersAndStringParametersForBackup.length ===
              0
            ) {
              // console.log('All data written.');
              this.writingData = false;
              await this.handleBackUpIsDone(res, currentHardwareNumber);
              this.step = 6;
            } else {
              this.startSubscribeForBackUpParameters(
                res,
                currentHardwareNumber,
              );
              // console.log('All data not written.', this.deviceQuery.parametersAndStringParametersForBackup);
              for (const parameter of this.deviceQuery
                .parametersAndStringParametersForBackup) {
                if (typeof parameter.value === "string") {
                  this.connectApiService.writeStringParameterToDevice({
                    ...parameter,
                    value: parameter.value as string,
                  });
                } else {
                  this.connectApiService.writeParameterToDevice({
                    ...parameter,
                    value: parameter.value as number,
                    ecuId: parameter.ecuId,
                  });
                }

                await this.sleep(100);
              }
            }
          },
        });
  }
  /*
 private async handleBackUpIsDone(
    res: any,
    currentHardwareNumber: any,
  ): Promise<void> {
    const units = res?.unitsToDeactivate ?? [];

    const activeUid =
      this.parameter.ecuId === 6
        ? this.serialNumber
        : `${this.serialNumber}-${currentHardwareNumber}`;

    const unitToSetAsActive = units.find(
      (unit: IHardwareVersion) => unit.uid === activeUid,
    );

     if (unitToSetAsActive) {
     await this.firestoreService.setDeviceAsActive(unitToSetAsActive);
  }

 

    await this.firestoreService.setDeviceAsActive(unitToSetAsActive);
   

    const oldUnits = units.filter(
      (unit: IHardwareVersion) => unit.uid !== activeUid,
    );
    await Promise.all(
      oldUnits.map((unit: IHardwareVersion) =>
        this.firestoreService.setDeviceAsInactive(unit),
      ),
    );
    /*setTimeout(() => {
      units
        .filter((device: any) => device.uid !== activeUid)
        .forEach((unit: IHardwareVersion) => {
          this.firestoreService.setDeviceAsInactive(unit);
        });
      console.log("updateFirestoreDevice");
     
    }, 3000);*/
  /* await this.firestoreService.updateFirestoreDevice();
  }*/
  private async handleBackUpIsDone(
    res: any,
    currentHardwareNumber: any,
  ): Promise<void> {
    const units: IHardwareVersion[] = res?.unitsToDeactivate ?? [];

    const activeUid =
      this.parameter.ecuId === 6
        ? this.serialNumber
        : `${this.serialNumber}-${currentHardwareNumber}`;

    const unitToSetAsActive = units.find((unit) => unit.uid === activeUid);
    const devicesCol = collection(
      this.angularFirestore,
      CONFIG.firebaseCollection.devices,
    );

    const MAX_RETRIES = 3;
    const RETRY_DELAY_MS = 2000;

    const executeWithRetry = async (
      operation: () => Promise<void>,
      attempt = 1,
    ): Promise<void> => {
      try {
        await operation();
      } catch (error) {
        const code = (error as { code?: string })?.code;
        const isConnectionError =
          code === "unavailable" ||
          code === "deadline-exceeded" ||
          code === "resource-exhausted";

        if (isConnectionError && attempt < MAX_RETRIES) {
          console.warn(
            `Connection issue, retrying attempt ${attempt}/${MAX_RETRIES}...`,
          );
          await new Promise((resolve) =>
            setTimeout(resolve, RETRY_DELAY_MS * attempt),
          ); // exponential backoff
          return executeWithRetry(operation, attempt + 1);
        }

        // Non-retryable error or max retries reached — rethrow to caller
        throw error;
      }
    };

    // Step 1: batch (atomic — either fully commits or fully fails, safe to retry)
    await executeWithRetry(async () => {
      const batch = writeBatch(this.angularFirestore);
      const devicesCol = collection(
        this.angularFirestore,
        CONFIG.firebaseCollection.devices,
      );

      if (unitToSetAsActive) {
        batch.set(
          doc(devicesCol, activeUid),
          { ...unitToSetAsActive, isInactive: false, isSparePart: false },
          { merge: true },
        );
      } else {
        // No previous unit found
        console.warn(
          `No existing unit found for uid: ${activeUid}, skipping batch set`,
        );
      }

      units
        .filter((unit) => unit.uid !== activeUid)
        .forEach((unit) => {
          batch.update(doc(devicesCol, unit.uid), { isInactive: true });
        });

      await batch.commit();
    });

    // Step 2: sync full device data — runs only if batch succeeded
    await executeWithRetry(async () => {
      this.firestoreService.forceFlag = true;
      await this.firestoreService.updateFirestoreDevice();
      this.firestoreService.forceFlag = false;
    });
  }

  private mergedataWithoutStringParametersFromDefFile(dataWithoutStringParameters: {
    parameterData: IParameterData[];
  }) {
    // FETCH DEFAULT SETTINGS FOR THE PARAMETERS THAT WERENT UPLOADED AT THE FACTORY

    dataWithoutStringParameters.parameterData =
      dataWithoutStringParameters?.parameterData.map((param) => {
        var paramIdAsNumber = parseInt(param.parameterId.toString());
        var valueAsNumber = parseInt(param.value.toString());
        return {
          ...param,
          parameterId:
            paramIdAsNumber < 1000
              ? this.parameter.ecuId * 1000 + paramIdAsNumber
              : paramIdAsNumber,
          value: valueAsNumber,
          //ecuId: this.parameter.ecuId as ECU_ID,
        };
      });

    var compHW = this.deviceQuery.hardwareVersions.find(
      (x) => x.ecuId === this.parameter.ecuId,
    );
    if (!compHW) {
      return;
    }
    var compFile = this.definitionQuery.compatibleFile(
      compHW?.ecuId,
      compHW?.buildNumber,
      compHW?.compVersion,
    );

    var defaultParameters = compFile?.parameterDefinition.parameterList.filter(
      (param) =>
        !dataWithoutStringParameters.parameterData.find(
          (x) => x.parameterId === param.parameterId,
        ) &&
        param.defaultValue !== undefined &&
        param.defaultValue !== null,
    );
    if (!defaultParameters) {
      return;
    }
    dataWithoutStringParameters.parameterData = [
      ...dataWithoutStringParameters.parameterData,
      ...defaultParameters.map((param) => {
        return {
          parameterId:
            param.parameterId < 1000
              ? this.parameter.ecuId * 1000 + param.parameterId
              : param.parameterId,
          ecuId: this.parameter?.ecuId,
          value: param.defaultValue ?? 0,
          id: this.parameter.ecuId,
          responseType: "OK",
          status: ParamResponseResult.OK,
          parameter: {
            ...param,
          },
        };
      }),
    ];

    //console.log('DATA WITHOUT STRINGPARAMS', dataWithoutStringParameters, 'DEFAULTPARAMETERS', defaultParameters);
    return dataWithoutStringParameters;
  }

  private mergedataWithStringParametersFromDefFile(dataWithStringParameters: {
    parameterData: IParameterData[];
    stringParameterData: stringparametertemp[];
  }) {
    // FETCH DEFAULT SETTINGS FOR THE PARAMETERS THAT WERENT UPLOADED AT THE FACTORY

    dataWithStringParameters.parameterData =
      dataWithStringParameters.parameterData.map((param) => {
        var paramIdAsNumber = parseInt(param.parameterId.toString());
        var valueAsNumber = parseInt(param.value.toString());
        return {
          ...param,
          parameterId:
            paramIdAsNumber < 1000
              ? 6 * 1000 + paramIdAsNumber
              : paramIdAsNumber,
          value: valueAsNumber,
        };
      });

    dataWithStringParameters.stringParameterData =
      dataWithStringParameters.stringParameterData.map((param) => {
        var paramIdAsNumber = parseInt(param.paramId.toString());
        var valueAsString = param.stringValue?.toString();
        return {
          ...param,
          paramId:
            paramIdAsNumber < 1000
              ? 6 * 1000 + paramIdAsNumber
              : paramIdAsNumber,
          stringValue: valueAsString,
        };
      });

    var compHW = this.deviceQuery.hardwareVersions.find(
      (x) => x.ecuId === this.parameter.ecuId,
    );
    if (!compHW) {
      return;
    }
    var compFile = this.definitionQuery.compatibleFile(
      compHW.ecuId,
      compHW.buildNumber,
      compHW.compVersion,
    );
    if (!compFile) {
      return;
    }
    var defaultStringParameters =
      compFile.parameterDefinition.parameterList.filter(
        (param) =>
          !dataWithStringParameters.stringParameterData.find(
            (x) => x.paramId === param.parameterId,
          ) &&
          param.defaultValue !== undefined &&
          param.defaultValue !== null &&
          param.dataType === "STR",
      );

    var defaultParameters = compFile?.parameterDefinition?.parameterList.filter(
      (param) =>
        !dataWithStringParameters.parameterData.find(
          (x) => x.parameterId === param.parameterId,
        ) &&
        param.defaultValue !== undefined &&
        param.defaultValue !== null &&
        param.dataType !== "STR",
    );

    dataWithStringParameters.parameterData = [
      ...dataWithStringParameters.parameterData,
      ...defaultParameters.map((param) => {
        return {
          parameterId:
            param.parameterId < 1000
              ? 6 * 1000 + param.parameterId
              : param.parameterId,
          ecuId: 6,
          value: param.defaultValue ?? 0,
          id: 6,
          responseType: "OK",
          status: ParamResponseResult.OK,
          parameter: {
            ...param,
          },
        };
      }),
    ];

    dataWithStringParameters.stringParameterData = [
      ...dataWithStringParameters.stringParameterData,
      ...defaultStringParameters.map((param) => {
        return {
          parameter: {
            ...param,
          },
          stringValue: param?.defaultValue?.toString(),
          paramId:
            param.parameterId < 1000
              ? 6 * 1000 + param.parameterId
              : param.parameterId,
          status: ParamResponseResult.OK,
          eventType: StringParameterEventType.READ,
        };
      }),
    ];

    /*console.log(
        'DATA WITH STRINGPARAMETERS',
        dataWithStringParameters,
        'DEFAULT STRING PARAMETERS',
        defaultStringParameters,
        'DEFAULT PARAMETERS',
        defaultParameters
      );*/
    return dataWithStringParameters;
  }

  private sleep(time: number) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  public finishConfiguration() {
    this.deviceService.setIsBackuping(false);
    this.searchingSparePart = false;

    if (this.ecuName === "TCU") {
      this.deviceQuery.specificParameterData$(1151).subscribe((para) => {
        if (para) {
          para.value = 0;
        }
      });
      this.deviceQuery.toggleSparePartFlags(1, false);
    }
    if (this.ecuName === "CCU") {
      this.deviceQuery.specificParameterData$(2162).subscribe((para) => {
        if (para) {
          para.value = 0;
        }
      });
      this.deviceQuery.toggleSparePartFlags(2, false);
    }
    if (this.ecuName === "HMI") {
      this.deviceQuery.specificParameterData$(6107).subscribe((para) => {
        if (para) {
          para.value = 0;
        }
      });
      this.deviceQuery.toggleSparePartFlags(6, false);
    }
    this.parametersAndStringParametersForBackupSubscription?.unsubscribe();
    this.modalService.dismissModal("SparePartModalServiceComponent");
    // this.modalService.dismissModal('InactiveUnitModalComponent');
    if (this.upgradeProgressSubscription) {
      this.upgradeProgressSubscription.unsubscribe();
    }
    this.items = [];
    this.changedItems = [];
    this.firmwareSparePart = {} as IFirmwareFile;
    this.softwareFile = {} as StorageReference;
    this.fileSelected = false;
    this.isChecked = false;
    this.isFirmwareDiff = false;
    this.softwareVersionHeartBeat = null;
    this.currentSparepartUnit = null;
    this.bleWebService.handleDisconnectForSparePart();
    //this.hardwareSubs.unsubscribe();
  }

  public finishRemoteConfiguration() {
    this.deviceService.setIsBackuping(false);
    this.searchingSparePart = false;
    this.modalService.dismissModal("SparePartModalServiceComponent");
    this.items = [];
    this.changedItems = [];
    this.firmwareSparePart = {} as IFirmwareFile;
    this.softwareFile = {} as StorageReference;
    this.fileSelected = false;
    this.isChecked = false;
    this.isFirmwareDiff = false;
    this.softwareVersionHeartBeat = null;
    this.currentSparepartUnit = null;
    this.firmwareSent = false;
    this.remoteUserService.stopRemoteSupportFromServiceTool();
    this.router.navigate(["/reload"], { replaceUrl: true });
    this.userService.updateLatestConnectionInfo();

    //this.router.navigate(["/"]);
    // this.bleWebService.handleDisconnectForSparePart();
    //this.hardwareSubs.unsubscribe();
  }

  public closeModal() {
    // this.hardwareSubs.unsubscribe();
    this.searchingSparePart = false;
    this.bleWebService.handleDisconnectForSparePart();
    this.modalService.dismissModal("SparePartModalServiceComponent");
    // this.modalService.dismissModal('InactiveUnitModalComponent');
    if (this.upgradeProgressSubscription) {
      this.upgradeProgressSubscription.unsubscribe();
    }

    this.items = [];
    this.changedItems = [];
    this.firmwareSparePart = {} as IFirmwareFile;
    this.softwareFile = {} as StorageReference;
    this.fileSelected = false;
    this.isChecked = false;
    this.isFirmwareDiff = false;
    this.softwareVersionHeartBeat = null;
    this.currentSparepartUnit = null;
  }

  public cancelFirmwareUpdate() {
    this.firmwareUpdateCancel = true;

    if (this.ecuName === "TCU") {
      this.deviceQuery.specificParameterData$(1151).subscribe((para) => {
        if (para) {
          para.value = 0;
        }
      });
    }
    if (this.ecuName === "CCU") {
      this.deviceQuery.specificParameterData$(2162).subscribe((para) => {
        if (para) {
          para.value = 0;
        }
      });
    }
    if (this.ecuName === "HMI") {
      this.deviceQuery.specificParameterData$(6107).subscribe((para) => {
        if (para) {
          para.value = 0;
        }
      });
    }
    this.step = 6;
    this.items = [];
  }

  public async onChangeFirmwareClicked() {
    // console.log("this.role", this.role);

    const selected = await this.modalService.openFilePickerModal(
      "systemversion",
      this.role,
    );
    if (!selected) {
      
      this.goBackfirmware();
    } else {
      this.softwareFile = {} as StorageReference;
      this.selectedFile = null;
      this.firmwarePrepared = false;
      this.selectedFile = await selected;
      //console.log("Selected:", this.selectedFile);
      if (this.selectedFile) {
        this.softwareFile = ref(this.angularFireStorage, this.selectedFile);
      }
      if (this.softwareFile) {
        this.step = 7;
        this.preparingFirmware(this.softwareFile);
      }
    }
  }

  public goBack() {
    this.searchingSparePart = false;
    this.serialNumber = "";
    this.serialNumberInput = "";
    this.softwareVarient = -1;
    this.lastConnectedDate = null;
    this.unitBackupDate = null;
    this.firmwareSparePart = {} as IFirmwareFile;
    this.softwareFile = {} as StorageReference;
    this.autoSoftwareFile = {} as StorageReference;
    this.fileSelected = false;
    this.isChecked = false;
    this.isFirmwareDiff = false;
    this.items = [];
    this.selectedFile = null;
    this.step = 1;
  }

  public goBackfirmware() {
    this.step = 2;
    //this.softwareFile = {} as StorageReference;
    //this.selectedFile = null;
  }
  ngOnDestroy(): void {
    //this.hardwareSubs.unsubscribe();
    this.searchingSparePart = false;
    this.deviceService.setIsBackuping(false);
    this.parametersAndStringParametersForBackupSubscription?.unsubscribe();
    // this.modalService.dismissModal('SparePartModalServiceComponent');
    // this.modalService.dismissModal('InactiveUnitModalComponent');
    if (this.upgradeProgressSubscription) {
      this.upgradeProgressSubscription.unsubscribe();
    }
  }
}
